package top.wcpe.allincore.ui.runtime.element

import kotlin.jvm.JvmStatic

/**
 * Button 视觉变体。DSL 中使用小写字符串值，运行期未知值回退为 [FILLED]。
 *
 * @property dsl DSL 中使用的小写字符串值
 */
enum class ButtonVariant(private val dsl: String) {
    FILLED("filled"),
    TONAL("tonal"),
    OUTLINED("outlined"),
    TEXT("text"),
    ELEVATED("elevated"),
    ;

    /** DSL 中使用的小写字符串值。 */
    fun dslValue(): String = dsl

    companion object {
        /** 解析 DSL 值，未知 / null 值回退 [FILLED]。 */
        @JvmStatic
        fun fromString(value: String?): ButtonVariant = tryParse(value) ?: FILLED

        /** 尝试按 DSL 值或枚举名（大小写不敏感）解析；无匹配或 null 返回 null。 */
        @JvmStatic
        fun tryParse(value: String?): ButtonVariant? {
            val normalized = value?.trim()?.lowercase() ?: return null
            return entries.firstOrNull {
                it.dsl == normalized || it.name.lowercase() == normalized
            }
        }
    }
}
